import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useStore } from "vuex";
import staticData from "@/assets/data/dataScreen.json";
import { defineComponent, onMounted, onBeforeUnmount, onUnmounted, reactive, ref, nextTick } from "vue";
export default defineComponent({
  name: "Thought",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var timerActivity = ref();
    var total = ref(0);
    var store = useStore();
    onBeforeUnmount(function () {
      //清除定时器
      clearInterval(timerActivity.value);
    });

    function testMove() {
      clearInterval(timerActivity.value);
    }

    function testMend() {
      startActivity();
    }

    function startActivity() {
      //清除定时器
      clearInterval(timerActivity.value); //定时器触发周期

      var speed = ref(50);
      timerActivity.value = setInterval(MarqueeTest, speed.value);
    }

    var rollHtml = ref();

    function MarqueeTest() {
      rollHtml.value = document.getElementsByClassName("roll");
      var test1 = rollHtml.value[0];

      if (test1.offsetHeight == 0) {
        test1 = rollHtml.value[0];
      } else {
        //如果列表数量过少不进行滚动
        if (test1.children.length < 6) {
          clearInterval(timerActivity.value);
          return;
        }

        test1.scrollTop += 1;

        if (test1.scrollTop == test1.scrollHeight - test1.clientHeight) {
          var a = test1.children[0];
          test1.removeChild(a);

          if (Data.tableData.length % 2 == 1) {
            a.className = a.className == "bot-bot" ? "blue bot-bot" : "bot-bot";
          }

          test1.append(a);
        }
      }
    }

    var Data = reactive({
      tableData: []
    });
    onMounted(function () {
      if (store.state.system.demonstration) {
        Data.tableData = staticData.activityData;
        total.value = 30;
        nextTick(function () {
          startActivity();
        });
      } else {
        getList();
        nextTick(function () {
          startActivity();
        });
        taskGetActivity();
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getActivityDataScreen();

              case 2:
                _context.next = 4;
                return getActivityDataScreenTotal();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();

    var timerActivitys;

    var taskGetActivity = function taskGetActivity() {
      timerActivitys = setInterval(function () {
        getActivityDataScreen();
        getActivityDataScreenTotal(); // clearInterval(timerActivitys);
        // taskGetActivity();
      }, 10000);
    };

    onUnmounted(function () {
      //清除定时器（列表滚动的）
      clearInterval(timerActivity.value); //清除轮训的定时器

      clearInterval(timerActivitys);
    });

    var getActivityDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getActivityDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.tableData = res.data;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getActivityDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //总数


    var getActivityDataScreenTotal = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getActivityDataScreenTotal"]();

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  total.value = res.data;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getActivityDataScreenTotal() {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      timerActivity: timerActivity,
      Data: Data,
      total: total,
      testMove: testMove,
      testMend: testMend,
      rollHtml: rollHtml,
      getList: getList,
      getActivityDataScreen: getActivityDataScreen
    };
  }
});